import styled from 'styled-components';

import Lock from 'components/Icons/Lock';
export { StyledTabs, StyledTab } from 'components/Tabs/styles';

export const StyledLock = styled(Lock)`
  width: 18px;
  fill: black;
  fill-opacity: 0.26;
`;

export const SectionCard = styled.div`
  background-color: ${({ theme }) => theme.palette.common.white};
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.divider};
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }
`;
